import * as React from 'react';
import { Spinner } from '@gjensidige/core-spinner';
import styles from './SpinnerRow.module.less';
import { Row } from '@gjensidige/core-grid';
export const SpinnerRow = ({ spinnerSize }) => (React.createElement(Row, { className: styles.spinnerCentered },
    React.createElement(Spinner, { size: spinnerSize })));
